export default {
  contained: {
    margin: '3px 0px 0px 0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
};
